import React from 'react';

function MainContent() {
  return (
    <main className="main-content">
      <section id="home" className="hero">
        <h2>Welcome to the Farm</h2>
        <p>Grooming & Horsemanship lessons, Animal Assisted Therapies, Horticultural Therapies, Birthday parties</p>
      </section>

      <section id="about" className="about">
        <h2>Equine Assisted Therapy</h2>
        <p>"We believe everybody, young or old, regardless of limitation or adaptive needs, should be able to experience the unique learning environment we provide here at Bramble Farm. We hope to bring some healing and self-restoration in the style of a British care farm, to our beautiful setting just over 2 hours from NYC and Philadelphia, in the lake region of the northern Pocono Mountains."</p>
        <p>Laura Martinelli Path Intl. CTRI, Owner, Director</p>
      </section>

      <section className="benefits">
        <h3>Benefits of Equine-Assisted Therapeutics</h3>
        <ul>
          <li>Improved Balance</li>
          <li>Self Control</li>
          <li>Increased quality of life</li>
        </ul>
        <p>Individually tailored farm based lessons for children, youths and veterans with physical, mental, emotional and behavioral disabilities led by PATH International certified instructor Laura Martinelli.</p>
      </section>


      <section className="volunteer">
        <h3>Become a Volunteer</h3>
        <p>With the aim of helping as many people as possible, we always seek enthusiastic volunteers. Please contact us for more info.</p>
      </section>
    </main>
  );
}

export default MainContent;